<template lang="pug">
.quotation-list
  GenericCard.productList(size='85' :ignoreMaxWidth='true')
    .sticky-top.bg-white
      .d-flex.px-4.py-4
        CustomerCompactDetailHeader(:data='customer')

        PanelTitleRight.ml-auto(
          title='รายการใบเสนอราคา'
          :subtitle='tableData ? `${totalRows} รายการ`:`...`'
          v-model='filterDate'
        )
    .d-flex.align-items-end.px-4.py-2
      CustomSearchBox.ml-auto(
        v-model='filterSearch'
        type='text' placeholder='ค้นหาด้วยเลขที่รายการ'
        :isLoading='isLoading'
      )

    hr.mb-0

    LoadedContentWrapper.flex-fill(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      .py-2.px-3
        CustomTable(
          :columns='tableColumns'
          :data='filteredTableData'
          :showIndexes='true'
          :startIndex='pageFirstRowIndex'
          @itemClicked='showModal'
        )

      .sticky-bottom.bg-white
        hr.m-0
        .px-4.py-3
          CustomPagination(
            v-model='currentPage'
            :total='totalPage'
          )

  modal(
    name='quotation'
    width='90%' height='95%'
    transition='modal-transition'
  )
    QuotationDetail(
      :customer='customer'
      :quotation='selectedItem'
      @closeButtonClicked='hideModal'
      @makeASellButtonClicked='makeASell'
    )
</template>

<script>
/* eslint-disable arrow-body-style */
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

import QuotationDetail from '@/components/history/dialogs/Quotation/QuotationDetail.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
  },
  watch: {
    customer() {
      this.loadData();
    },

    // reload data
    filterDate: {
      handler() { this.currentPage = 1; this.loadData(); },
      deep: true,
    },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      // return this.tableData.filter((item) => {
      //   return (
      //     // (this.filterDate === '' || this.$dateUtils.isInRange(item.date, this.filterDate))
      //     // (!this.filterStatus || item.status === this.filterStatus)
      //     (!KEYWORD || item.entryNo.toUpperCase().includes(KEYWORD))
      //   );
      // });
      return this.tableData;
    },
  },
  data() {
    return {
      isLoading: false,

      filterDate: '',
      filterSearch: '',
      // filterStatus: undefined,
      tableData: [],
      tableColumns: {
        entryNo: {
          title: 'เลขที่รายการ',
          align: 'left',
          type: 'EntryNo',
        },
        date: {
          title: 'วันที่ทำรายการ',
          align: 'left',
          type: Date,
        },
        time: {
          title: 'เวลา',
          align: 'left',
          type: this.$api.customer.COL_TYPE.Time,
        },
        total: {
          title: 'ยอดรวม',
          align: 'right',
          type: Number,
          computed(row) {
            let total = 0;
            if (row.products) {
              for (let i = 0; i < row.products.length; i += 1) {
                const PROD = row.products[i];
                total += Number(PROD.price);
              }
            }
            return total;
          },
        },
      },

      // pagination
      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItem: {},
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // reset data
      this.tableData = null;

      try {
        const res = await this.$api.customer.history.sell(
          this.customer.id,
          this.currentPage,
          this.filterDate.from,
          this.filterDate.to,
          'quotation',
          this.filterSearch,
        );
        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    showModal(e) {
      this.selectedItem = e.data;
      this.$modal.show('quotation');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('quotation');
    },
    makeASell() {
      this.hideModal();
      this.$router.push({
        name: 'sales.new-order', // can't use path, cause it WON'T allow passing hidden params
        params: {
          ...this.selectedItem, // pass eveything inside the quotation

          // customerId: this.customer.id,
          customer: this.customer,
          remarks: `จากใบเสนอราคาหมายเลข ${this.selectedItem.entryNo ? this.selectedItem.entryNo : '-'} (#${this.selectedItem.id})`,

          quotationIdToRemove: this.selectedItem.id,
        },
      });
    },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    this.loadData();
  },
  components: {
    CustomerCompactDetailHeader,
    QuotationDetail,
  },
};
</script>

<style lang="scss">
.quotation-list {
  .panel-title {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 24px;
  }
  .panel-subtitle {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 17px;
  }
}
</style>
